module.exports = __webpack_public_path__ + "img/JAOC_POP_PestoSauce_rectangular.de9fb10b.png";